import '@fontsource-variable/dm-sans'
import '@fontsource/tomorrow'
import './styles.css'

import { StrictMode } from 'react'

import ReactDOM from 'react-dom/client'

import { AppEntry } from './app-entry'
import reportWebVitals from './lib/report-web-vitals'

// Render the app
const rootElement = document.getElementById('app')
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <AppEntry />
    </StrictMode>
  )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
